import React, { useEffect } from "react";
import { connect } from "react-redux";
import { compose, withHandlers } from "recompose";
import { withTranslation } from "react-i18next";
import * as Yup from "yup";
import * as R from "ramda";
import { Content } from "@worcket/common/components/layout";
import { isLoading } from "@worcket/common/hocs";
import styled from "styled-components";

import * as gtag from "../../lib/gtag";
import Page from "../../components/display/Page";
import { Form, FormConfig } from "../../components/controls/FormikForm";
import Element from "../../components/structure/Element";
import Message from "../../components/feedback/Message";
import DetailsForm from "../../forms/team/Details";
import UsersForm from "../../forms/team/Users";
import { createTeam, CREATE_TEAM } from "../../store/actions/team";
import { formatTeamUsers } from "../../store/selectors/team";
import Button from "../../components/Button";

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Debe tener al menos 2 caracteres")
    .max(50, "Debe tener menos de 50 caracteres")
    .required("Requerido")
});

const initialValues = {
  name: ""
};

const Create = ({ t, handleCreateTeam, loading, company }) => {
  useEffect(() => {
    gtag.event({
      category: "Vacancies",
      action: "Vacancies.Group.New",
      label: company.id
    });
  }, [company.id]);

  return (
    <Page>
      <Content>
        <h1>{t("team:newTeam")}</h1>
        <Element marginBottom={24}>{t("team:description")}</Element>
        <FormConfig
          validationSchema={validationSchema}
          initialValues={initialValues}
          onSubmit={handleCreateTeam}
        >
          {({ isValid }) => (
            <Form>
              <DetailsForm />
              <UsersForm />
              <Message marginBottom={24} marginTop={24} type="primary-lighter">
                {t(`team:addUsersLater`)}
              </Message>
              <ButtonContainer>
                <Button
                  disabled={!isValid}
                  loading={loading}
                  type="primary"
                  size="lg"
                  htmlType="submit"
                >
                  {t("team:create")}
                </Button>
              </ButtonContainer>
            </Form>
          )}
        </FormConfig>
      </Content>
    </Page>
  );
};

export default compose(
  withTranslation(["team"]),
  connect(
    R.applySpec({
      users: R.pathOr([], ["company", "users"]),
      company: R.pathOr({}, ["company"])
    }),
    { createTeam }
  ),
  isLoading(CREATE_TEAM),
  withHandlers({
    handleCreateTeam: ({ users, createTeam }) => team =>
      createTeam(formatTeamUsers(users, team))
  })
)(Create);
